export const faqs = [
  {
    header: "GENERAL OVERVIEW",
    questions: [
      {
        no: 1,
        question: "What is Addie?",
        answer: "Addie is an AI-Agent that conducts personalized one-on-one telephonic conversations with employees at scale. It acts as a companion throughout their journey in the organization, helping companies gain deep insights into employee sentiment, well-being, engagement, and productivity.",
      },
      {
        no: 2,
        question: "How does Addie work?",
        answer: "Addie engages with employees through natural language, telephonic and human-like conversations. It collects quantitative data, analyse patterns, and presents deep actionable insights to HR leaders, managers, and CXOs.",
      },
      {
        no: 3,
        question: "What kind of topics does Addie cover in conversations?",
        answer: "Addie can talk to employees on almost all topics throughout his/her employment journey. Primarily around Career aspirations, workload, well-being, manager relationships, growth opportunities, mental health, culture fit, feedback on processes, feedback on policy, feedback on performance review, feedback on the 1st few days of joining, Grievance and POSH conversation and even EXIT Interviews.",
      },
      {
        no: 4,
        question: "How frequently does Addie engage with employees?",
        answer: "You can configure Addie’s frequency - bi-weekly, monthly, quarterly or annually through various campaigns, based on the needs of your organization. Addie adapts to employee availability and context.",
      },
    ],
  },
  {
    header: "VALUE AND OUTCOMES",
    questions: [
      {
        no: 5,
        question: "What problems does Addie solve for an organization?",
        answer: "Addie helps reduce employee turnover, boosts engagement, uncovers silent suffering, and provides visibility into team sentiment, enabling faster, data-backed decisions.",
      },
      {
        no: 6,
        question: "How does Addie help managers or HR leaders?",
        answer: "Managers and HR teams receive concise summaries and real-time insights about their teams’ well-being, concerns, and morale. It also provides both group and individual level insights.",
      },
      {
        no: 7,
        question: "What’s the business ROI of using Addie?",
        answer: "By preventing early attrition, identifying disengagement, and boosting employee morale, Addie helps improve retention, productivity, and the overall employee experience, directly impacting the bottom line.",
      },
    ],
  },
  {
    header: "DATA AND PRIVACY",
    questions: [
      {
        no: 8,
        question: "Is Addie’s data secure?",
        answer: "Yes. All conversations are encrypted. Addie complies with enterprise-grade data privacy regulations like GDPR and CCPA.",
      },
      {
        no: 9,
        question: "Can employees trust that their conversations are private?",
        answer: "Absolutely. Addie is transparent about its purpose and assures confidentiality. Only aggregated, anonymized insights are shared with the company unless employees explicitly opt in for specific concerns to be shared.",
      },
      {
        no: 10,
        question: "Does Addie replace HR or managers?",
        answer: "No. Addie complements human roles by acting as an always-on listener. It surfaces issues early and supports HR and managers in taking timely action.",
      },
    ],
  },
  {
    header: "CUSTOMIZATION AND INTEGRATION",
    questions: [
      {
        no: 11,
        question: "Can we customize Addie’s tone, language, or questions?",
        answer: "Yes. Addie can be tailored to your company’s culture, tone of voice, industry-specific topics, and languages.",
      },
      {
        no: 12,
        question: "Does Addie integrate with our existing HR systems?",
        answer: "Yes. Addie integrates with tools like Workday, SuccessFactors, ServiceNow, and others to sync employee data and deliver insights within your workflow.",
      },
      {
        no: 13,
        question: "Can we deploy Addie globally across multiple locations and teams?",
        answer: "Absolutely. Addie is designed to scale across geographies with different time zone and teams.",
      },
    ],
  },
  {
    header: "USAGE AND EXPERIENCE",
    questions: [
      {
        no: 14,
        question: "Do employees need to install anything to use Addie?",
        answer: "No. Addie works via web and speaks to employee through a telephonic conversation. It can even be integrated with collaboration tools like Slack, MS Teams, or emails, through custom integrations.",
      },
      {
        no: 15,
        question: "How do employees know when to talk to Addie?",
        answer: "Addie provides the employee with an option to choose the convenient date and time for the conversation.",
      },
      {
        no: 16,
        question: "What happens if an employee raises a critical concern?",
        answer: "Addie can flag serious issues (e.g., harassment, suicidal) using alert mechanisms and escalate them to designated SPOC and provides pop up in the dashboard. This alert mechanism can also be customized based on enterprise requirements.",
      },
    ],
  },
  {
    header: "PILOT AND IMPLEMENTATION",
    questions: [
      {
        no: 17,
        question: "How long does it take to implement Addie?",
        answer: "A typical implementation takes 1–2 weeks, if there are no customization. If there are customization and integrations requirement, this timeline will increase based on the complexity of the customization and integrations. For pilots, we can go live in under 7 days.",
      },
      {
        no: 18,
        question: "Is there a minimum number of users required to start using Addie?",
        answer: "No strict minimum, but we recommend pilots with at least 100+ employees for meaningful insights.",
      },
      {
        no: 19,
        question: "Can we start with a pilot before a full rollout?",
        answer: "Yes. We offer short-term, low-cost pilot programs so you can experience Addie's value before committing to a larger deployment.",
      },
    ],
  },
  {
    header: "PRICING AND SUPPORT",
    questions: [
      {
        no: 20,
        question: "How is Addie priced?",
        answer: "Addie is priced based on the number of employees and usage tiers. We offer flexible packages for SMBs, mid-sized, and large enterprises.",
      },
      {
        no: 21,
        question: "What kind of support does Addie provide?",
        answer: "We offer dedicated onboarding, customer success managers, and technical support. Our team ensures smooth rollout and adoption.",
      },
      {
        no: 22,
        question: "Is training provided for admins or users?",
        answer: "Yes. We provide training sessions and onboarding resources for admins and employee champions, along with help articles for users.",
      },
    ],
  },
  {
    header: "FUTURE AND INNOVATION",
    questions: [
      {
        no: 23,
        question: "What’s on Addie’s product roadmap?",
        answer: "We’re actively working on more predictive insights, sentiment timeline dashboards, manager nudges, and integrations with wellness tools and AI voice agents.",
      },
      {
        no: 24,
        question: "Can Addie evolve with our organization?",
        answer: "Yes. Addie continuously learns from your data and adapts its capabilities as your organization grows and priorities evolve.",
      },
    ],
  },
];